import { makeValidated } from '../utils';
import interpolate from '../interpolate';
import schema from '../../schema/set-components-map.schema.json';

const mapSetComponentsMap = action => ({
  type: 'LAYOUT_SET_COMPONENTS_MAP',
  payload: {
    value: action.data.value,
  },
});

const setComponentsMap = (context, event, meta) => {
  const validated = makeValidated(schema);
  return mapSetComponentsMap(
    validated(interpolate(meta.action, event, context))
  );
};

export default setComponentsMap;
